import { posthog } from './posthog';

export function trackEvent(eventName, properties) {
    if (typeof window === 'undefined') return;
    if (typeof posthog.capture !== 'function') return;

    posthog.capture(eventName, properties);
}

// Identify the signed-in user. Safe to call on every sign-in / session restore
// (posthog.identify is idempotent). No-op for an id-less user or uninitialized PostHog.
export function identifyUser(user) {
    if (!user?.id) return;
    if (typeof window === 'undefined') return;
    if (typeof posthog.identify !== 'function') return;
    posthog.identify(
        String(user.id),
        {
            email: user.email,
            name: user.name,
            email_verified: !!user.emailVerified,
        },
        { created_at: user.createdAt },
    );
}

// Associate events with the current workspace (group) and stamp plan/workspace
// onto every subsequent event via super properties.
export function setWorkspaceContext(workspace) {
    if (!workspace?.id) return;
    if (typeof window === 'undefined') return;
    if (typeof posthog.group !== 'function') return;
    if (typeof posthog.register !== 'function') return;
    const plan = workspace.plan_slug || 'free';
    posthog.group('workspace', String(workspace.id), {
        name: workspace.title,
        plan,
        role: workspace.my_role,
    });
    posthog.register({
        plan,
        workspace_id: String(workspace.id),
        workspace_role: workspace.my_role,
    });
}

// Clear identity, super properties, and group associations (shared-device safety).
export function resetAnalytics() {
    if (typeof window === 'undefined') return;
    if (typeof posthog.reset !== 'function') return;
    posthog.reset();
}

// Canvas editor event helper: stamps the shared { page, type } props so every
// editor event is consistent. Extra props (e.g. { count, key_type }) merge on top.
export function trackCanvasEvent(eventName, props = {}) {
    trackEvent(eventName, { page: 'app', type: 'canvas', ...props });
}
